import { call, put, select } from 'redux-saga/effects';
import { TAB_INDIVIDUAL_NOTICE } from '../../../constants/message';
import { getMessages } from '../../../api/messageApi';
import { refreshMessagesSuccess } from '../../actions/messageActions';
import { errorHandler } from '../errorSaga';
import { completeBody, sorted } from './common';

export function* refreshMessagesRequestHandler({ payload }) {
  try {
    const isAuthenticated = yield select((state) => state.auth.isAuthenticated);
    if (!isAuthenticated) {
      // 未ログイン時はスキップ
      return;
    }
    const { isIndividual, channel } = payload;
    const { data: messages } = yield call(getMessages, { isIndividual, channel });
    const currentTab = yield select((state) => state.message.currentTab);
    if (isIndividual === (currentTab === TAB_INDIVIDUAL_NOTICE)) {
      yield put(refreshMessagesSuccess({ messages: sorted(completeBody(messages)) }));
    }
  } catch (error) {
    // TODO 暗黙の更新で画面側にエラーを通知してしまって良いのかどうか
    yield call(errorHandler, { error });
  }
}
